module.exports = __webpack_public_path__ + "static/img/9.5dfb459.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/9.jpg
// module id = d8Du
// module chunks = 1